
import Vue from 'vue'
import Navbar from '../components/Navbar.vue'

export default Vue.extend({
  components: {
    Navbar,
  },
  data() {
    return {
      inLoading: false,
      title: '',
    }
  },
  head() {
    return {
      // 日本語に指定
      htmlAttrs: {
        lang: 'ja',
      },
    }
  },
  created() {
    this.setListener()
  },
  beforeDestroy() {
    // 多重バインド防止のため、イベントをoff（破棄）する
    this.$nuxt.$off('setTitle', this.setHeader)
    this.$nuxt.$off('loadingFinish', this.loadingFinish)
  },
  mounted() {
    this.$nextTick(() => {
      this.$nuxt.$loading.start()
      this.inLoading = true
    })
  },
  methods: {
    setListener(): void {
      this.$nuxt.$on('setTitle', this.setHeader)
      this.$nuxt.$on('loadingFinish', this.loadingFinish)
    },
    setHeader(title: string): void {
      this.title = title || ''
    },
    loadingFinish(duration: number): void {
      this.$nuxt.$loading.manualFinish(duration)
    },
  },
})
